import { Component, OnInit, Input, ViewChild } from "@angular/core";
import { BaseComponent } from "../../base.component";

import {
  Form,
  FormControl,
  FormGroup,
  FormArray,
  Validators,
  ValidatorFn,
} from "@angular/forms";
import * as _ from "lodash";
import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { DataService } from "../../_services/data.service";
import { AlertService } from "../../_services/alert.service";

@Component({
  moduleId: module.id,
  selector: "rikuz",
  templateUrl: "rikuz.component.html",
  styleUrls: ["./rikuz.component.css"],
})
export class RikuzComponent extends BaseComponent {
  public formGroupObj: FormGroup;
  public errorMessage: string;
  public message: string;

  constructor(
    public dataService: DataService,
    private alertService: AlertService,
    public sessionManager: SessionManagerService
  ) {
    super(dataService, sessionManager);
  }

  run() {
    this.formGroupObj = new FormGroup({
      fromDate: new FormControl(null, Validators.required),
      toDate: new FormControl(null),
    });
  }

  submit() {
    this.errorMessage = undefined;
    this.message = undefined;
    if (!this.loading) {
      this.loading = true;
      this.dataService
        .postEntity("rikuz-service", this.formGroupObj.getRawValue())
        .subscribe(
          (data) => {
            if (data && data.errorMessage)
              this.errorMessage = data.errorMessage;
            else if (data && data.message) this.message = data.message;
            this.loading = false;
          },
          (error) => {
            let body = error.json && error.json();
            this.alertService.error(
              body && body.statusText
                ? this.base.messages[body.statusText]
                  ? this.base.messages[body.statusText]
                  : decodeURIComponent(body.statusText)
                : (error && error.statusText) || error
            );
            this.loading = false;
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/rikuz/rikuz.component.ts